/*
 * fx-auth 权限指令 by shw
 * @params moduleAuth: 模块权限
 * @params detialsAuth: 详情权限
 * @params dynamicRule: 动态规则
 * exmple:
 * 1.v-fx-auth:moduleAuth.detialsAuth 根据当前模块的详情权限 进行显示(允许|, & 规则)
 * example:v-fx-auth:basic-archives_organ-manage.add-shop|add-rdc|add-store|add-section
 * 2.v-fx-auth:moduleAuth.detialsAuth="dynamicRule"
 * a.动态规则dynamicRule如果为false, 则无权限, 如果动态规则为true, 则根据模块详情权限 进行显示
 * b.动态规则dynamicRule如果为function, 且存在moduleAuth, 则向function传入参数hasAuthByDetails, 作用为接收details-name, 返回权限(允许|, & 规则)
 * c如果不存在moduleAuth, 则function无任何参数
 * 3.v-fx-auth ="dynamicRule" 仅仅根据动态权限 进行显示
 */
import type { DirectiveBinding } from 'vue'
import { watch } from 'vue'
import vuex from '@/store'
import utils from '@/js/utils'
interface DirectiveEl extends HTMLElement {
	fxDirDisplay?: string
}
const hideEl = function (el: HTMLElement) {
	el.style.display = 'none'
}
const getDetailsAuth = function (moduleName: string) {
	return vuex.getters.getAuthDetails[moduleName] || {}
}
const hasAuth = function (authModule: string, authDetailsName: string) {
	const detailsAuthMap = getDetailsAuth(authModule)
	return utils.logicJudgmentStr(authDetailsName, (detail: string) => {
		return !!detailsAuthMap[detail]
	})
}
const hasAuthByDetails = function (authModule: string) {
	return function (authDetailsName: string) {
		return hasAuth(authModule, authDetailsName)
	}
}
const verifyAuth = function (el: DirectiveEl, binding: DirectiveBinding): void | boolean {
	if (binding.value === false) {
		hideEl(el)
		return false
	}
	if (typeof binding.value === 'function') {
		const value = binding.arg ? binding.value(hasAuthByDetails(binding.arg)) : binding.value()
		if (!value) {
			hideEl(el)
			return false
		}
	}
	if (binding.arg && utils.isEmptyObj(getDetailsAuth(binding.arg))) {
		hideEl(el)
		return false
	}
	if (binding.arg && binding.modifiers && !utils.isEmptyObj(binding.modifiers)) {
		const authDetailsName = Object.keys(binding.modifiers)[0]
		if (!hasAuth(binding.arg, authDetailsName)) {
			hideEl(el)
			return false
		}
	}
	el.style.display = el.fxDirDisplay!
}
export default {
	mounted: (el: DirectiveEl, binding: DirectiveBinding): void => {
		el.fxDirDisplay = el.style.display
		verifyAuth(el, binding)
		watch(() => vuex.getters.getAuthDetails, () => {
			verifyAuth(el, binding)
		})
	},
	updated: verifyAuth
}
